import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import FriendshipGame from '../../../Game/FriendshipGame';
import UserService from '../../../../controllers/UserService';
import AuthService from '../../../../controllers/AuthService';
import UserAndActivitySummary from './UserAndActivitySummary';
import $ from 'jquery';

const ClassesSummary = props => {

    const filterYear = props.filterYear ?? null
    const filterTerm = props.filterTerm ?? null
    const [totalStudentCount, setTotalStudentCount] = useState(0);
    const [totalTeacherCount, setTotalTeacherCount] = useState(0);
    const [currentTab, setCurrentTab] = useState('SECONDARY');
    const [homeroomD1, setHomeroomD1] = useState([]);
    const [dataResponse, setDataResponse] = useState(null);
    const user = AuthService.getCurrentUser();

    useEffect(() => {
        if (!filterYear || !filterTerm) {
            return;
        }
        loadAPI("SECONDARY_SCHOOL")
    }, [filterYear, filterTerm])

    const loadAPI = (cGrade) => {
        let classGrade = "SECONDARY_SCHOOL"
        if (cGrade.indexOf('PRIMARY') > -1) {
            classGrade = "PRIMARY_SCHOOL"
        }
        const params = {
            "domain": user.domain.name,
            "year": filterYear,
            "term": filterTerm,
            "grade": classGrade,
        };
        UserService.activitiesGradeYearAll(params).then((response) => {
            const data = response.data.data
            setDataResponse(data)
            dataRender(null, data)
        });
    }

    const dataRender = (classGrade, dataResponse) => {
        // if (!classGrade) {
        //     classGrade = 'SECONDARY'
        // }
        // const dataAll = dataResponse.filter(function (d) { return d.grade.includes(classGrade) });
        const dataAll = dataResponse;
        let tempData = [null, null, null, null, null, null];
        let countActivity = 0
        let countTeacher = 0
        let countStudent = 0
        for (let i = 0; i < 6; i++) {
            if (dataAll[i]) {
                countActivity += dataAll[i].totalActivities
                countTeacher += dataAll[i].totalTeachers
                countStudent += dataAll[i].totalStudents

                var tempIndex = dataAll[i].gradeYear - 1;

                tempData[tempIndex] = dataAll[i];
            }
        }
        setHomeroomD1(tempData);
        setTotalTeacherCount(countTeacher)
        setTotalStudentCount(countStudent)
    }

    const changeClassGrade = (val) => {
        setCurrentTab(val)
        loadAPI(val)
        // dataRender(val, dataResponse)
    }

    const showHideSection = (section) => {
        console.log(section);
        var targetID = $('#' + section);
        var tragetClass = $('.' + section);
        if (targetID.hasClass('showhide-red')) {
            targetID.removeClass('showhide-red');
            targetID.addClass('showhide-green');
            tragetClass.hide();
        } else {
            targetID.removeClass('showhide-green');
            targetID.addClass('showhide-red');
            tragetClass.show();
        }
    }

    return (
        <>
            <Row className="font-sarabun mt-3 mb-3 ">
                <Col xs={12} className="text-center">
                    <h1 className='text-center page-headline'>
                        ข้อมูลแบ่งตามระดับชั้น
                    </h1>
                    <button className="btn-showhide border-gray showhide-red d-none d-lg-inline" id="showHideClassesSummary" onClick={() => showHideSection('showHideClassesSummary')}> </button>
                </Col>
            </Row>
            <Row className="font-sarabun my-3 showHideClassesSummary class-summary mb-lg-3">
                <Col xs={12} className='tab-switcher text-center'>
                    <Button className={`${currentTab == 'SECONDARY' ? 'active' : 'inactive'} switcher md-switcher`} onClick={() => changeClassGrade('SECONDARY')}>มัธยมศึกษา</Button>
                    <Button className={`${currentTab == 'PRIMARY' ? 'active' : 'inactive'} switcher md-switcher mt-2 mt-lg-0 ml-lg-3`} onClick={() => changeClassGrade('PRIMARY')}>ประถมศึกษา</Button>
                </Col>
                <Col xs={12} lg={6} className="mt-3 mt-lg-4 mb-lg-4">
                    <h3 className="text-center text-lg-right pl-lg-0 mb-0 total-text" data-testid="dashboard-room-total-student"><img src="/images/icons/person_icon.png" width="10" className="mb-2" /> นักเรียนทั้งหมด {totalStudentCount} คน</h3>
                </Col>
                <Col xs={12} lg={6} className="my-lg-4">
                    <h3 className="text-center text-lg-left pl-lg-0 mb-0 total-text" data-testid="dashboard-room-total-teacher"><img src="/images/icons/person_icon.png" width="10" className="mb-2" /> คุณครูทั้งหมด {totalTeacherCount} คน</h3>
                </Col>
                <Col xs={12}>
                    <FriendshipGame year={filterYear} term={filterTerm} grade={currentTab} showHeader={true} />
                </Col>
                <Col xs={12}>
                    {(currentTab && homeroomD1) ? <UserAndActivitySummary currentTab={currentTab} homeroomD1={homeroomD1} /> : null}
                </Col>
            </Row>
        </>
    )
}

export default ClassesSummary
